import logo from './logo.svg';
import './App.css';
import AppRoutes from './AppRoutes';
import NavBar from './Components/NavBar';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Footer from './Components/Footer';
function App() {
  
  const dispatch = useDispatch();
  let userdata;

    useEffect(()=>{
        userdata = JSON.parse(sessionStorage.getItem("udata"))
        if(userdata!=null){
            dispatch({type: 'update_idk', payload: userdata._id})
            dispatch({type: 'update_uname', payload: userdata.name})
            dispatch({type: 'update_eml', payload: userdata.email})
        }
    },[userdata])
  return (
    <>
      <NavBar />
      <AppRoutes/>
      <Footer/>
    </>
  );
}

export default App;
